import { render, staticRenderFns } from "./BaseSelectBox.vue?vue&type=template&id=2d524f03"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectBox.vue?vue&type=style&index=0&id=2d524f03&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports